<studio-dialog>
  <studio-dialog-title [text]="data.title"></studio-dialog-title>
  <studio-dialog-buttons-container>
    <studio-dialog-button
      precedence="secondary"
      [theme]="data.theme"
      [text]="data.declineLabel"
      (click)="dialogRef.close(data.declineValue)"
    ></studio-dialog-button>
    <studio-dialog-button
      precedence="primary"
      buttonTheme="error"
      [text]="data.confirmLabel"
      (click)="dialogRef.close(data.confirmValue)"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
